var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{attrs:{"id":"home"}},[_c('Banners'),_c('CategoriaCursos'),_c('Unidades'),_c('BlogFael')],1)}
var staticRenderFns = []

export { render, staticRenderFns }